import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modalConfig, setModalConfig] = useState(null);
    const resolveRef = useRef(null);

    const closeModal = useCallback(() => {
        setModalConfig(null);
        if (resolveRef.current) {
            resolveRef.current(false);
            resolveRef.current = null;
        }
    }, []);

    const handleConfirm = useCallback(() => {
        setModalConfig(null);
        if (resolveRef.current) {
            resolveRef.current(true);
            resolveRef.current = null;
        }
    }, []);

    const showAlert = useCallback((title, message, variant = 'primary') => {
        return new Promise((resolve) => {
            setModalConfig({
                type: 'alert',
                title,
                message,
                variant,
                onClose: () => {
                    setModalConfig(null);
                    resolve();
                }
            });
        });
    }, []);

    /**
     * 확인 창.
     *
     * 단추 이름을 부르는 쪽이 정할 수 있다. '취소 / 확인' 은 무엇을 되돌리는지
     * 말하지 않아서, 이미 끝난 일을 되돌리는 것처럼 읽힐 때가 있다 -- 점검을
     * 제출한 뒤 '다음 곳 이어서' 를 물을 때 '취소' 가 제출을 무르는 것처럼
     * 보였다.
     */
    const showConfirm = useCallback(
        (title, message, variant = 'primary', labels = {}) => {
            return new Promise((resolve) => {
                resolveRef.current = resolve;
                setModalConfig({
                    type: 'confirm',
                    title,
                    message,
                    variant,
                    confirmText: labels.confirm,
                    cancelText: labels.cancel,
                });
            });
        },
        [],
    );

    return (
        <ModalContext.Provider value={{ showAlert, showConfirm, modalConfig, closeModal, handleConfirm }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};

export default ModalContext;
